import React from 'react';
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import { getCompatibleTextColor, ZIPPITY_COLORS } from '../../calendar/colors';

const CUSTOM_MESSAGE_KNOWN_VALUES = [
  'Fuel',
  'Wheel Related',
  'Seasonal Tire',
  'Detailing',
  'Variable Pricing',
  'Tire Rotation & Balance',
  'Exterior Detailing',
  'Scratch Removal',
];

const KNOWN_VALUES = {
  schedule_types: [
    'mechanical',
    'fuel',
    'detailing',
    'tires',
    'oil',
    'state_inspection',
  ],
  display_category: ['package', 'standard', 'addon'],
  custom_message_1: CUSTOM_MESSAGE_KNOWN_VALUES,
  custom_message_2: CUSTOM_MESSAGE_KNOWN_VALUES,
  tax_type: ['service', 'itemized', 'bundled'],
  maintenance_repair_category: ['maintenance', 'repair', 'cleaning', 'other'],
  // note that tags is not currently shown
  tags: [
    'Battery services',
    'Belts',
    'Brakes',
    'Bulbs',
    'Cleaning (maintenance customers)',
    'Custom services',
    'Detailing',
    'Diagnostics and Emissions',
    'Exhaust',
    'Filters',
    'Fluid service',
    'Free services',
    'Maintenance packages',
    'Oil changes',
    'Other',
    'Powertrain, Steering and Suspension',
    'Sensors',
    'Spark plugs',
    'Tire services',
    'Wipers',
    'Maintenance',
    'Repair',
  ],
};

const getColor = (source, name) => {
  const index = KNOWN_VALUES[source] && KNOWN_VALUES[source].indexOf(name);
  if (index >= 0) {
    return ZIPPITY_COLORS[index % ZIPPITY_COLORS.length];
  }
  return null;
};

const ChipsField = ({ record, source, subSource }) => {
  // if a subSource is specified, access that (e.g. custom_message_1['internal_name'])
  let names = subSource
    ? record[source] && record[source][subSource]
    : record[source];

  if (!names) {
    return null;
  }

  // if names is actually a string, convert it to an array
  if (!Array.isArray(names)) names = [names];
  names.sort();

  return names.map((name) => {
    let nameCopy = name;
    if (source === 'child_service_offerings') {
      nameCopy = name.short_name;
    }
    const backgroundColor = getColor(source, nameCopy);
    const color = getCompatibleTextColor(backgroundColor);
    return (
      <Chip
        key={nameCopy}
        label={nameCopy}
        style={{ backgroundColor, color, fontSize: '11px' }}
      />
    );
  });
};

ChipsField.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  subSource: PropTypes.string,
};

ChipsField.defaultProps = {
  subSource: null,
};

export default ChipsField;
